export const SETTING_INVENTORY_PAGE_REQUEST = 'SETTING_INVENTORY_PAGE_REQUEST';
export const SETTING_INVENTORY_UPDATE_SETTING =
  'SETTING_INVENTORY_UPDATE_SETTING';
export const SETTING_INVENTORY_SET_ROLES = 'SETTING_INVENTORY_SET_ROLES';
export const SETTING_INVENTORY_SET_PERMISSIONS =
  'SETTING_INVENTORY_SET_PERMISSIONS';
